import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../../types';
import styles from '../../styles/TopNav.module.css';
import apiService from '../../services/api';

interface TopNavProps {
  collapsed: boolean;
  isMobile: boolean;
  onMobileMenuToggle: () => void;
  user: User | null;
}

const TopNav: React.FC<TopNavProps> = ({ collapsed, isMobile, onMobileMenuToggle, user }) => {
  const navigate = useNavigate();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);

  const getUserFullName = () => {
    if (!user) return 'User';
    return `${user.first_name} ${user.last_name}`.trim() || user.email;
  };

  const handleSignOut = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = `${apiService.getBaseURL()}/auth/signout/`;
  };

  const handleChangePassword = () => {
    navigate('/system-settings');
    setProfileDropdownOpen(false);
  };

  const submitChangePassword = async () => {
    console.log('Change password submitted');
  };

  const getUserInitials = () => {
    if (!user) return 'U';
    return `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase();
  };

  const formatDesignation = (designation: string | undefined) => {
    if (!designation) return 'No Designation';
    return designation
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <>
      <nav className={`${styles.topNav} ${collapsed ? styles.collapsed : ''}`}>
        <div>
          {isMobile && (
            <button className={styles.mobileMenuBtn} onClick={onMobileMenuToggle}>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"></path>
              </svg>
            </button>
          )}
        </div>

        <div>
          <div 
            className={styles.userProfile} 
            onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
          >
            <div className={styles.userAvatar}>
              {getUserInitials()}
            </div>
            {!isMobile && (
              <div>
                <div className={styles.userName}>{getUserFullName()}</div>
                <div className={styles.userRole}>{user ? formatDesignation(user.designation) : 'No Designation'}</div>
              </div>
            )}
          </div>

          {profileDropdownOpen && (
            <div className={styles.profileDropdownHeader}>
              <div className={styles.profileDropdownLogo}>
                <div className={styles.logoContainer}>
                  <img src="/images/wallet.svg" alt="WorkWallet" height="22" />
                  WorkWallet
                </div>
                <button 
                  className={styles.profileSignoutLink} 
                  onClick={handleSignOut}
                  type="button"
                >
                  Sign out
                </button>
              </div>
              <div className={styles.profileDropdownRow}>
                <div className={styles.profileAvatar}>
                  {user?.first_name?.[0] || 'U'}
                </div>
                <div className={styles.profileInfo}>
                  <div className={styles.profileName}>{getUserFullName()}</div>
                  <div className={styles.profileEmail}>{user?.email || 'user@example.com'}</div>
                  <span 
                    className={styles.profileLink} 
                    onClick={handleChangePassword}
                  >
                    Reset Password
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default TopNav;
